export default __webpack_public_path__ + "static/media/collapse-two-arrows.5eeef511.svg";